import { useEffect, useState } from 'react'
import type { WakeLockPort, WakeLockState } from '@/platform/wakeLock'

/**
 * Écran maintenu allumé pendant une mission en cours. Le navigateur libère le verrou quand la page est masquée :
 * il est redemandé au retour au premier plan. Un refus est affiché, jamais redemandé en boucle.
 */
export function useWakeLock(port: WakeLockPort, active: boolean): WakeLockState {
  const [state, setState] = useState<WakeLockState>(port.supported ? 'released' : 'unsupported')

  useEffect(() => {
    if (!active || !port.supported) {
      void port.release()
      return
    }
    let cancelled = false
    const request = () => {
      if (document.hidden) return
      void port.request().then((next) => {
        if (!cancelled) setState(next)
      })
    }
    port.onRelease(() => {
      if (!cancelled) setState('released')
    })
    request()
    const onVisible = () => {
      if (!document.hidden) request()
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      cancelled = true
      document.removeEventListener('visibilitychange', onVisible)
      void port.release()
    }
  }, [port, active])

  return state
}
